
<div class="modal-header py-2">
  <h4 class="modal-title pull-left">{{ nome }}</h4>     
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>   
</div>
<div class="modal-body">  
  <p class="mb-0">ID Aluno: <strong>{{ idAluno }}</strong> </p>
  <p class="mb-0">Mapa Anterior: <strong>{{ idMapaAnterior }} </strong></p>
  <p class="mb-0">Nível descrição: <strong>{{ nivelDescricao }} </strong></p>
  <p class="mb-0">Horário descrição: <strong>{{ horario }} </strong></p>
  <p class="mb-0">Professor Nome: <strong>{{ professor }} </strong></p>
  <p class="mb-0">Data da transferência: <strong>{{ dataTransferencia }} </strong></p>
</div><!-- /.modal-body -->      